<template>
  <div>
    <div class="admin-top-bar">
      <h1 class="p-0 clickable" @click="$router.push({name: 'admin-dashboard'})">
        CR Admin -
        <span v-if="application">v{{application.version}}</span>
      </h1>
    </div>
    <div class="admin-sub-bar d-flex justify-content-center align-items-center">
      <router-link
        class="sub-bar-item m-2"
        :to="{name: 'admin-dashboard'}"
      >
        <i class="fa fa-home"></i>
      </router-link>
      <router-link
        class="sub-bar-item m-2"
        :to="{name: 'admin-user-list'}"
      >
        {{ $tc('word.user', 2) }}
      </router-link>
      <router-link
        class="sub-bar-item m-2"
        :to="{name: 'admin-external'}"
      >
        External
      </router-link>
      <router-link
        class="sub-bar-item m-2"
        :to="{name: 'admin-research-list'}"
      >
        {{ $tc('word.research', 2) }}
      </router-link>
      <router-link
        class="sub-bar-item m-2"
        :to="{name: 'admin-items'}"
      >
        {{ $tc('word.item', 2) }}
      </router-link>
      <router-link
        class="sub-bar-item m-2"
        :to="{name: 'admin-newsletter-registration-list'}"
      >
        {{ $tc('word.newsletter', 2) }}
      </router-link>
      |
      <router-link
        class="sub-bar-item m-2"
        :to="{name: 'log-list'}"
      >
        {{ $t('word.logs') }}
      </router-link>
      <router-link
        class="sub-bar-item m-2"
        :to="{name: 'dashboard'}"
      >
        {{ $t('word.platform') }}
      </router-link>
      |
      <a
        :href="getBackendUrl('/admin/')"
        class="sub-bar-item m-2"
      >
        Django Admin
      </a>
    </div>
  </div>
</template>

<script>
import api from '@/common/api';
import { getBackendUrl } from '@/common/utils/api';

export default {
  name: 'TopBar',
  data() {
    return {
      application: null,
    };
  },
  methods: {
    getBackendUrl,
    async fetchApplication() {
      const response = await api.get('public/application/meta/');
      this.application = response.data;
    },
  },
  created() {
    this.fetchApplication();
  },
};
</script>

<style scoped>
.admin-top-bar {
  background: #417690;
  height: 48px;
  color: #f5dd5d;
  padding: 10px 40px;
  overflow: hidden;
  font-size: 14px;
}

.admin-top-bar h1 {
  font-weight: 300;
  font-size: 25px;
}

.admin-sub-bar {
  background: #264b5d;
  height: 36px;
}

.sub-bar-item {
  border-bottom: 1px solid rgba(255, 255, 255, 0.25);
  color: #eee;
  font-size: 11px;
  text-transform: uppercase;
  transition: color 0.15s, background 0.15s;
}

.sub-bar-item:hover {
  color: #539fc5;
}
</style>
